import { SvgIcon, SvgIconProps } from '@mui/material';

const CircleDivider = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 4 5"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 4, height: 5, fill: 'none', ...props.sx }}
    data-testid="circleDividerIcon"
  >
    <circle cx="2" cy="2.5" r="2" fill="#ABAFBF" />
  </SvgIcon>
);

export default CircleDivider;
